<template>
  <div class="mapContent" ref="mapContent">
    <div>
      <button class="saveBtn" @click="saveRouter()">保存</button>
      <button class="saveBtn" @click="clearRouter()">清空缓存</button>
      <button class="saveBtn" @click="close()">关闭</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["reportType"],
  data() {
    return {
      roadObj: {
        roadA: {
          roadList: [
            {
              id: "roadA_1",
              children: ["92", "40", "21", "14"],
            },
            {
              id: "roadA_2",
              children: ["92", "40", "21", "14"],
            },
            {
              id: "roadA_3",
              children: ["92", "40", "21", "14"],
            },
            {
              id: "roadA_4",
              children: ["92", "40", "21", "14"],
            },
            {
              id: "roadA_5",
              children: ["92", "40", "21", "14"],
            },
            {
              id: "roadA_6",
              children: ["92", "40", "21", "14"],
            },
          ],
          isSel: false,
        },
        roadB: {
          roadList: [
            {
              id: "roadB_1",
              children: ["125"],
            },
            {
              id: "roadB_2",
              children: ["125"],
            },
            {
              id: "roadB_3",
              children: ["125"],
            },
          ],
          isSel: false,
        },
        roadC: {
          roadList: [
            {
              id: "roadC_1",
              children: ["122", "127"],
            },
            {
              id: "roadC_2",
              children: ["122", "127"],
            },
          ],
          isSel: false,
        },
        roadD: {
          roadList: [
            {
              id: "roadD_1",
              children: ["103"],
            },
          ],
          isSel: false,
        },
        roadE: {
          roadList: [
            {
              id: "roadE_1",
              children: ["90"],
            },
          ],
          isSel: false,
        },
        roadF: {
          roadList: [
            {
              id: "roadF_1",
              children: ["72"],
            },
          ],
          isSel: false,
        },
        roadG: {
          roadList: [
            {
              id: "roadG_1",
              children: ["52"],
            },
          ],
          isSel: false,
        },
        roadH: {
          roadList: [
            {
              id: "roadH_1",
              children: ["39"],
            },
          ],
          isSel: false,
        },
        roadI: {
          roadList: [
            {
              id: "roadI_1",
              children: ["20"],
            },
          ],
          isSel: false,
        },
        roadJ: {
          roadList: [
            {
              id: "roadJ_1",
              children: ["11", "12", "13"],
            },
          ],
          isSel: false,
        },
        roadK: {
          roadList: [
            {
              id: "roadK_1",
              children: ["10"],
            },
          ],
          isSel: false,
        },
        roadL: {
          roadList: [
            {
              id: "roadL_1",
              children: ["9"],
            },
          ],
          isSel: false,
        },
        roadM: {
          roadList: [
            {
              id: "roadM_1",
              children: ["8"],
            },
          ],
          isSel: false,
        },
        roadN: {
          roadList: [
            {
              id: "roadN_1",
              children: ["16"],
            },
          ],
          isSel: false,
        },
        roadO: {
          roadList: [
            {
              id: "roadO_1",
              children: ["48", "54", "58"],
            },
          ],
          isSel: false,
        },
        roadP: {
          roadList: [
            {
              id: "roadP_1",
              children: ["93", "108", "123"],
            },
            {
              id: "roadP_2",
              children: ["93", "108", "123"],
            },
            {
              id: "roadP_3",
              children: ["93", "108", "123"],
            },
          ],
          isSel: false,
        },
        roadQ: {
          roadList: [
            {
              id: "roadQ_1",
              children: ["124"],
            },
          ],
          isSel: false,
        },
        roadR: {
          roadList: [
            {
              id: "roadR_1",
              children: ["50"],
            },
          ],
          isSel: false,
        },
        roadS: {
          roadList: [
            {
              id: "roadS_1",
              children: ["76"],
            },
          ],
          isSel: false,
        },
        roadT: {
          roadList: [
            {
              id: "roadT_1",
              children: ["84"],
            },
          ],
          isSel: false,
        },
        roadU: {
          roadList: [
            {
              id: "roadU_1",
              children: ["105", "109", "118"],
            },
            {
              id: "roadU_2",
              children: ["105", "109", "118"],
            },
          ],
          isSel: false,
        },
        roadV: {
          roadList: [
            {
              id: "roadV_1",
              children: ["29"],
            },
          ],
          isSel: false,
        },
        roadW: {
          roadList: [
            {
              id: "roadW_1",
              children: ["28"],
            },
          ],
          isSel: false,
        },
        roadX: {
          roadList: [
            {
              id: "roadX_1",
              children: ["27"],
            },
          ],
          isSel: false,
        },
        roadY: {
          roadList: [
            {
              id: "roadY_1",
              children: ["26"],
            },
          ],
          isSel: false,
        },
        roadZ: {
          roadList: [
            {
              id: "roadZ_1",
              children: ["25"],
            },
          ],
          isSel: false,
        },
        roadAA: {
          roadList: [
            {
              id: "roadAA_1",
              children: ["126"],
            },
          ],
          isSel: false,
        },
        roadBB: {
          roadList: [
            {
              id: "roadBB_1",
              children: ["24"],
            },
          ],
          isSel: false,
        },
        roadCC: {
          roadList: [
            {
              id: "roadCC_1",
              children: ["23"],
            },
            {
              id: "roadCC_2",
              children: ["23"],
            },
            {
              id: "roadCC_3",
              children: ["23"],
            },
            {
              id: "roadCC_4",
              children: ["23"],
            },
            {
              id: "roadCC_5",
              children: ["23"],
            },
          ],
          isSel: false,
        },
        roadDD: {
          roadList: [
            {
              id: "roadDD_1",
              children: ["35"],
            },
          ],
          isSel: false,
        },
        roadEE: {
          roadList: [
            {
              id: "roadEE_1",
              children: ["32"],
            },
          ],
          isSel: false,
        },
        roadEEE: {
          roadList: [
            {
              id: "roadEEE_1",
              children: ["30"],
            },
          ],
          isSel: false,
        },
        roadFF: {
          roadList: [
            {
              id: "roadFF_1",
              children: ["33"],
            },
          ],
          isSel: false,
        },
        roadFFF: {
          roadList: [
            {
              id: "roadFFF_1",
              children: ["31"],
            },
          ],
          isSel: false,
        },
        roadGG: {
          roadList: [
            {
              id: "roadGG_1",
              children: ["34"],
            },
          ],
          isSel: false,
        },
        roadHH: {
          roadList: [
            {
              id: "roadHH_1",
              children: ["36"],
            },
            {
              id: "roadHH_2",
              children: ["36"],
            },
            {
              id: "roadHH_3",
              children: ["36"],
            },
          ],
          isSel: false,
        },
        roadII: {
          roadList: [
            {
              id: "roadII_1",
              children: ["37"],
            },
          ],
          isSel: false,
        },
        roadJJ: {
          roadList: [
            {
              id: "roadJJ_1",
              children: ["38"],
            },
          ],
          isSel: false,
        },
        roadKK: {
          roadList: [
            {
              id: "roadKK_1",
              children: ["19"],
            },
          ],
          isSel: false,
        },
        roadLL: {
          roadList: [
            {
              id: "roadLL_1",
              children: ["18"],
            },
          ],
          isSel: false,
        },
        roadMM: {
          roadList: [
            {
              id: "roadMM_1",
              children: ["17"],
            },
          ],
          isSel: false,
        },
        roadNN: {
          roadList: [
            {
              id: "roadNN_1",
              children: ["47"],
            },
          ],
          isSel: false,
        },
        roadOO: {
          roadList: [
            {
              id: "roadOO_1",
              children: ["46"],
            },
          ],
          isSel: false,
        },
        roadPP: {
          roadList: [
            {
              id: "roadPP_1",
              children: ["45"],
            },
          ],
          isSel: false,
        },
        roadQQ: {
          roadList: [
            {
              id: "roadQQ_1",
              children: ["44"],
            },
          ],
          isSel: false,
        },
        roadRR: {
          roadList: [
            {
              id: "roadRR_1",
              children: ["43"],
            },
          ],
          isSel: false,
        },
        roadSS: {
          roadList: [
            {
              id: "roadSS_1",
              children: ["42"],
            },
          ],
          isSel: false,
        },
        roadTT: {
          roadList: [
            {
              id: "roadTT_1",
              children: ["51"],
            },
          ],
          isSel: false,
        },
        roadUU: {
          roadList: [
            {
              id: "roadUU_1",
              children: ["62"],
            },
          ],
          isSel: false,
        },
        roadVV: {
          roadList: [
            {
              id: "roadVV_1",
              children: ["61"],
            },
          ],
          isSel: false,
        },
        roadWW: {
          roadList: [
            {
              id: "roadWW_1",
              children: ["60"],
            },
          ],
          isSel: false,
        },
        roadXX: {
          roadList: [
            {
              id: "roadXX_1",
              children: ["56"],
            },
            {
              id: "roadXX_2",
              children: ["56"],
            },
            {
              id: "roadXX_3",
              children: ["56"],
            },
          ],
          isSel: false,
        },
        roadYY: {
          roadList: [
            {
              id: "roadYY_1",
              children: [],
            },
          ],
          isSel: false,
        },
        roadZZ: {
          roadList: [
            {
              id: "roadZZ_1",
              children: ["55"],
            },
          ],
          isSel: false,
        },
        roadAB: {
          roadList: [
            {
              id: "roadAB_1",
              children: ["65"],
            },
          ],
          isSel: false,
        },
        roadAC: {
          roadList: [
            {
              id: "roadAC_1",
              children: ["64"],
            },
          ],
          isSel: false,
        },
        roadAD: {
          roadList: [
            {
              id: "roadAD_1",
              children: ["59"],
            },
          ],
          isSel: false,
        },
        roadAE: {
          roadList: [
            {
              id: "roadAE_1",
              children: ["69"],
            },
            {
              id: "roadAE_2",
              children: ["69"],
            },
          ],
          isSel: false,
        },
        roadAF: {
          roadList: [
            {
              id: "roadAF_1",
              children: ["68"],
            },
          ],
          isSel: false,
        },
        roadAG: {
          roadList: [
            {
              id: "roadAG_1",
              children: ["67"],
            },
          ],
          isSel: false,
        },
        roadAH: {
          roadList: [
            {
              id: "roadAH_1",
              children: ["71"],
            },
          ],
          isSel: false,
        },
        roadAI: {
          roadList: [
            {
              id: "roadAI_1",
              children: ["70"],
            },
          ],
          isSel: false,
        },
        roadAJ: {
          roadList: [
            {
              id: "roadAJ_1",
              children: ["66"],
            },
          ],
          isSel: false,
        },
        roadAK: {
          roadList: [
            {
              id: "roadAK_1",
              children: ["75"],
            },
          ],
          isSel: false,
        },
        roadAL: {
          roadList: [
            {
              id: "roadAL_1",
              children: ["74"],
            },
          ],
          isSel: false,
        },
        roadAM: {
          roadList: [
            {
              id: "roadAM_1",
              children: ["73"],
            },
          ],
          isSel: false,
        },
        roadAN: {
          roadList: [
            {
              id: "roadAN_1",
              children: ["78"],
            },
          ],
          isSel: false,
        },
        roadAO: {
          roadList: [
            {
              id: "roadAO_1",
              children: ["77"],
            },
          ],
          isSel: false,
        },
        roadAP: {
          roadList: [
            {
              id: "roadAP_1",
              children: ["83"],
            },
          ],
          isSel: false,
        },
        roadAQ: {
          roadList: [
            {
              id: "roadAQ_1",
              children: ["82"],
            },
          ],
          isSel: false,
        },
        roadAR: {
          roadList: [
            {
              id: "roadAR_1",
              children: ["81"],
            },
          ],
          isSel: false,
        },
        roadAS: {
          roadList: [
            {
              id: "roadAS_1",
              children: ["87"],
            },
          ],
          isSel: false,
        },
        roadAT: {
          roadList: [
            {
              id: "roadAT_1",
              children: ["80"],
            },
          ],
          isSel: false,
        },
        roadAU: {
          roadList: [
            {
              id: "roadAU_1",
              children: ["79"],
            },
          ],
          isSel: false,
        },
        roadAV: {
          roadList: [
            {
              id: "roadAV_1",
              children: ["89"],
            },
          ],
          isSel: false,
        },
        roadAW: {
          roadList: [
            {
              id: "roadAW_1",
              children: ["88"],
            },
          ],
          isSel: false,
        },
        roadAX: {
          roadList: [
            {
              id: "roadAX_1",
              children: ["86"],
            },
          ],
          isSel: false,
        },
        roadAY: {
          roadList: [
            {
              id: "roadAY_1",
              children: ["85"],
            },
          ],
          isSel: false,
        },
        roadAZ: {
          roadList: [
            {
              id: "roadAZ_1",
              children: ["102"],
            },
          ],
          isSel: false,
        },
        roadBA: {
          roadList: [
            {
              id: "roadBA_1",
              children: ["100"],
            },
          ],
          isSel: false,
        },
        roadBC: {
          roadList: [
            {
              id: "roadBC_1",
              children: ["101"],
            },
          ],
          isSel: false,
        },
        roadBD: {
          roadList: [
            {
              id: "roadBD_1",
              children: ["99"],
            },
          ],
          isSel: false,
        },
        roadBE: {
          roadList: [
            {
              id: "roadBE_1",
              children: ["104"],
            },
          ],
          isSel: false,
        },
        roadBF: {
          roadList: [
            {
              id: "roadBF_1",
              children: ["98"],
            },
          ],
          isSel: false,
        },
        roadBG: {
          roadList: [
            {
              id: "roadBG_1",
              children: ["97"],
            },
          ],
          isSel: false,
        },
        roadBH: {
          roadList: [
            {
              id: "roadBH_1",
              children: ["96"],
            },
          ],
          isSel: false,
        },
        roadBI: {
          roadList: [
            {
              id: "roadBI_1",
              children: ["95"],
            },
          ],
          isSel: false,
        },
        roadBJ: {
          roadList: [
            {
              id: "roadBJ_1",
              children: ["94"],
            },
          ],
          isSel: false,
        },
        roadBK: {
          roadList: [
            {
              id: "roadBK_1",
              children: ["111"],
            },
          ],
          isSel: false,
        },
        roadBL: {
          roadList: [
            {
              id: "roadBL_1",
              children: ["114"],
            },
          ],
          isSel: false,
        },
        roadBM: {
          roadList: [
            {
              id: "roadBM_1",
              children: ["115"],
            },
          ],
          isSel: false,
        },
        roadBN: {
          roadList: [
            {
              id: "roadBN_1",
              children: ["112"],
            },
          ],
          isSel: false,
        },
        roadBO: {
          roadList: [
            {
              id: "roadBO_1",
              children: ["119", "120"],
            },
          ],
          isSel: false,
        },
        roadBP: {
          roadList: [
            {
              id: "roadBP_1",
              children: ["113"],
            },
          ],
          isSel: false,
        },
        roadBQ: {
          roadList: [
            {
              id: "roadBQ_1",
              children: ["110"],
            },
          ],
          isSel: false,
        },
        roadBR: {
          roadList: [
            {
              id: "roadBR_1",
              children: ["116"],
            },
          ],
          isSel: false,
        },
      },
      routeKey: "",
    };
  },
  watch: {
    reportType: {
      handler(newVal, oldVal) {
        if (newVal == "日常巡查") {
          this.routeKey = "daily";
        } else if (newVal == "自定义巡查") {
          this.routeKey = "custom";
        } else if (newVal == "重点区域巡查") {
          this.routeKey = "keyPoint";
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    for (var i in this.roadObj) {
      this.dealRaod(i);
    }
  },
  methods: {
    close: function () {
      this.$emit("closeRouteSetting", true);
    },
    dealRaod: function (n) {
      var tmpRoad = this.roadObj[n];
      let tmpRoadId = n;
      let tmpRoadList = tmpRoad.roadList;
      tmpRoadList.forEach((item) => {
        var tmpNode = $('<div class="' + item.id + " " + tmpRoadId + '  "></div>');
        tmpNode.bind("click", () => {
          let nodeList = $("." + tmpRoadId);
          for (var j = 0; j < nodeList.length; j++) {
            let isSel = $(nodeList.get(j)).attr("isSel");
            if (isSel == "true") {
              $(nodeList.get(j)).attr("isSel", false);
              this.roadObj[n]["isSel"] = false;
              $(nodeList.get(j)).removeClass("isSel");
            } else {
              $(nodeList.get(j)).attr("isSel", true);
              this.roadObj[n]["isSel"] = true;
              $(nodeList.get(j)).addClass("isSel");
            }
          }
        });
        $(this.$refs.mapContent).append(tmpNode);
      });
    },
    saveRouter: function () {
      let totalList = [];
      for (var i in this.roadObj) {
        if (this.roadObj[i]["isSel"]) {
          let roadList = this.roadObj[i]["roadList"];
          roadList.forEach((item) => {
            let tmpList = item.children;
            tmpList.forEach((item_) => {
              if ($.inArray(item_, totalList) < 0) {
                totalList.push(item_);
              }
            });
          });
        }
      }
      localStorage[this.routeKey + "_list"] = JSON.stringify(totalList);
      console.log(totalList);
      this.$emit("changeRoute", this.routeKey);
    },
    clearRouter: function () {
      localStorage[this.routeKey + "_list"] = "";
      this.$emit("changeRoute", this.routeKey);
    },
  },
};
</script>

<style lang="scss">
.saveBtn {
  width: 80px;
  height: 30px;
  display: inline-block;
}

.roadA_1 {
  position: absolute;
  width: 29px;
  height: 8px;
  left: 242px;
  transform: rotate(-4deg);
  top: 556px;
}

.roadA_2 {
  position: absolute;
  width: 521px;
  height: 8px;
  left: -35px;
  transform: rotate(85.5deg);
  top: 299px;
}

.roadA_3 {
  position: absolute;
  width: 139px;
  height: 7px;
  left: 201px;
  transform: rotate(-5deg);
  top: 35px;
}

.roadA_4 {
  position: absolute;
  width: 39px;
  height: 6px;
  left: 319px;
  transform: rotate(85deg);
  top: 46px;
}

.roadA_5 {
  position: absolute;
  width: 21px;
  height: 5px;
  left: 337px;
  transform: rotate(0deg);
  top: 63px;
}

.roadA_6 {
  position: absolute;
  width: 12px;
  height: 5px;
  left: 350px;
  transform: rotate(88deg);
  top: 67px;
}

.roadB_1 {
  position: absolute;
  width: 40px;
  height: 5px;
  left: 208px;
  transform: rotate(88deg);
  top: 65px;
}

.roadB_2 {
  position: absolute;
  width: 52px;
  height: 5px;
  left: 224px;
  transform: rotate(-5deg);
  top: 45px;
}

.roadB_3 {
  position: absolute;
  width: 40px;
  height: 5px;
  left: 254px;
  transform: rotate(88deg);
  top: 61px;
}

.roadC_1 {
  position: absolute;
  width: 17px;
  height: 5px;
  left: 212px;
  transform: rotate(86deg);
  top: 92px;
}

.roadC_2 {
  position: absolute;
  width: 52px;
  height: 5px;
  left: 218px;
  transform: rotate(-5deg);
  top: 85px;
}

.roadD_1 {
  position: absolute;
  width: 120px;
  height: 5px;
  left: 165px;
  transform: rotate(-93.5deg);
  top: 159px;
}

.roadE_1 {
  position: absolute;
  width: 36px;
  height: 5px;
  left: 215px;
  transform: rotate(-104deg);
  top: 236px;
}

.roadF_1 {
  position: absolute;
  width: 53px;
  height: 5px;
  left: 214px;
  transform: rotate(-96deg);
  top: 279px;
}

.roadG_1 {
  position: absolute;
  width: 176px;
  height: 5px;
  left: 164px;
  transform: rotate(-95.5deg);
  top: 393px;
}

.roadH_1 {
  position: absolute;
  width: 52px;
  height: 5px;
  left: 237px;
  transform: rotate(-95.5deg);
  top: 506px;
}

.roadI_1 {
  position: absolute;
  width: 29px;
  height: 5px;
  left: 252px;
  transform: rotate(-95.5deg);
  top: 546px;
}

.roadJ_1 {
  position: absolute;
  width: 193px;
  height: 6px;
  left: 264px;
  transform: rotate(-4deg);
  top: 550px;
}

.roadK_1 {
  position: absolute;
  width: 13px;
  height: 6px;
  left: 455px;
  transform: rotate(-4deg);
  top: 543px;
  z-index: 99;
}

.roadL_1 {
  position: absolute;
  width: 89px;
  height: 6px;
  left: 467px;
  transform: rotate(-4deg);
  top: 539.5px;
}

.roadM_1 {
  position: absolute;
  width: 46px;
  height: 6px;
  left: 550px;
  transform: rotate(-4deg);
  top: 535px;
}

.roadN_1 {
  position: absolute;
  width: 95px;
  height: 6px;
  left: 543px;
  transform: rotate(86deg);
  top: 489px;
}

.roadO_1 {
  position: absolute;
  width: 297px;
  height: 6px;
  left: 429px;
  transform: rotate(86deg);
  top: 294px;
}

.roadP_1 {
  position: absolute;
  width: 99px;
  height: 6px;
  left: 514px;
  transform: rotate(86deg);
  top: 97px;
}

.roadP_2 {
  position: absolute;
  width: 124px;
  height: 6px;
  left: 438px;
  transform: rotate(-1deg);
  top: 51px;
}

.roadP_3 {
  position: absolute;
  width: 86px;
  height: 6px;
  left: 354px;
  transform: rotate(-13.5deg);
  top: 62px;
}

.roadQ_1 {
  position: absolute;
  width: 94px;
  height: 6px;
  left: 265px;
  transform: rotate(-8deg);
  top: 75px;
}

.roadR_1 {
  position: absolute;
  width: 188px;
  height: 6px;
  left: 477px;
  transform: rotate(86deg);
  top: 346px;
}

.roadS_1 {
  position: absolute;
  width: 83px;
  height: 6px;
  left: 520px;
  transform: rotate(86deg);
  top: 211px;
}

.roadT_1 {
  position: absolute;
  width: 24px;
  height: 6px;
  left: 546px;
  transform: rotate(86deg);
  top: 158px;
}

.roadU_1 {
  position: absolute;
  width: 92px;
  height: 6px;
  left: 508px;
  transform: rotate(86deg);
  top: 101px;
}

.roadU_2 {
  position: absolute;
  width: 255px;
  height: 6px;
  left: 298px;
  transform: rotate(-5deg);
  top: 69px;
}

.roadV_1 {
  position: absolute;
  width: 86px;
  height: 6px;
  left: 266px;
  transform: rotate(-4deg);
  top: 528px;
}

.roadW_1 {
  position: absolute;
  width: 104px;
  height: 6px;
  left: 352px;
  transform: rotate(-4deg);
  top: 521px;
}

.roadX_1 {
  position: absolute;
  width: 12px;
  height: 6px;
  left: 455px;
  transform: rotate(-4deg);
  top: 517px;
  z-index: 99;
}

.roadY_1 {
  position: absolute;
  width: 20px;
  height: 6px;
  left: 466px;
  transform: rotate(-4deg);
  top: 516px;
}

.roadZ_1 {
  position: absolute;
  width: 48px;
  height: 6px;
  left: 485px;
  transform: rotate(-4deg);
  top: 514px;
}

.roadAA_1 {
  position: absolute;
  width: 20px;
  height: 6px;
  left: 533px;
  transform: rotate(-1.5deg);
  top: 512px;
}

.roadBB_1 {
  position: absolute;
  width: 13px;
  height: 6px;
  left: 553px;
  transform: rotate(-1.5deg);
  top: 511.5px;
}

.roadCC_1 {
  position: absolute;
  width: 8px;
  height: 6px;
  left: 566px;
  transform: rotate(-1.5deg);
  top: 511.5px;
}

.roadCC_2 {
  position: absolute;
  width: 15px;
  height: 6px;
  left: 568px;
  transform: rotate(-65.5deg);
  top: 506.5px;
}

.roadCC_3 {
  position: absolute;
  width: 16px;
  height: 6px;
  left: 570px;
  transform: rotate(-91.5deg);
  top: 493.5px;
}

.roadCC_4 {
  position: absolute;
  width: 16px;
  height: 6px;
  left: 569px;
  transform: rotate(-99deg);
  top: 480px;
}

.roadCC_5 {
  position: absolute;
  width: 14px;
  height: 5px;
  left: 564px;
  transform: rotate(-175deg);
  top: 474px;
}

.roadDD_1 {
  position: absolute;
  width: 33px;
  height: 5px;
  left: 531px;
  transform: rotate(-183deg);
  top: 474.5px;
}

.roadEE_1 {
  position: absolute;
  width: 22px;
  height: 5px;
  left: 553px;
  transform: rotate(-92deg);
  top: 482px;
}

.roadEEE_1 {
  position: absolute;
  width: 22px;
  height: 5px;
  left: 554px;
  transform: rotate(-92deg);
  top: 504px;
}

.roadFF_1 {
  position: absolute;
  width: 23px;
  height: 5px;
  left: 521px;
  transform: rotate(-92deg);
  top: 484px;
}

.roadFFF_1 {
  position: absolute;
  width: 23px;
  height: 5px;
  left: 522px;
  transform: rotate(-92deg);
  top: 505px;
}

.roadGG_1 {
  position: absolute;
  width: 36px;
  height: 5px;
  left: 530px;
  transform: rotate(0deg);
  top: 493px;
}

.roadHH_1 {
  position: absolute;
  width: 40px;
  height: 5px;
  left: 494px;
  transform: rotate(-5deg);
  top: 477px;
}

.roadHH_2 {
  position: absolute;
  width: 9px;
  height: 4px;
  left: 488px;
  transform: rotate(50deg);
  top: 477px;
}

.roadHH_3 {
  position: absolute;
  width: 21px;
  height: 4.5px;
  left: 479px;
  transform: rotate(85deg);
  top: 465px;
}

.roadII_1 {
  position: absolute;
  width: 60px;
  height: 5px;
  left: 453px;
  transform: rotate(86deg);
  top: 485px;
}

.roadJJ_1 {
  position: absolute;
  width: 53px;
  height: 5px;
  left: 324px;
  transform: rotate(86deg);
  top: 498px;
}

.roadKK_1 {
  position: absolute;
  width: 31px;
  height: 5px;
  left: 442px;
  transform: rotate(89deg);
  top: 530px;
}

.roadLL_1 {
  position: absolute;
  width: 31px;
  height: 5px;
  left: 449px;
  transform: rotate(89deg);
  top: 530px;
}

.roadMM_1 {
  position: absolute;
  width: 23px;
  height: 5px;
  left: 542px;
  transform: rotate(89deg);
  top: 526px;
}

.roadNN_1 {
  position: absolute;
  width: 91px;
  height: 6px;
  left: 258px;
  transform: rotate(-8deg);
  top: 475px;
}

.roadOO_1 {
  position: absolute;
  width: 50px;
  height: 6px;
  left: 346px;
  transform: rotate(-7deg);
  top: 466px;
}

.roadPP_1 {
  position: absolute;
  width: 86px;
  height: 6px;
  left: 395px;
  transform: rotate(-7deg);
  top: 458px;
}

.roadQQ_1 {
  position: absolute;
  width: 11px;
  height: 6px;
  left: 480px;
  transform: rotate(-7deg);
  top: 452px;
}

.roadRR_1 {
  position: absolute;
  width: 87px;
  height: 6px;
  left: 490px;
  transform: rotate(-6.5deg);
  top: 446.5px;
}

.roadSS_1 {
  position: absolute;
  width: 10px;
  height: 6px;
  left: 576px;
  transform: rotate(-6deg);
  top: 441px;
}

.roadTT_1 {
  position: absolute;
  width: 128px;
  height: 6px;
  left: 324px;
  transform: rotate(83deg);
  top: 398px;
}

.roadUU_1 {
  position: absolute;
  width: 50px;
  height: 6px;
  left: 332px;
  transform: rotate(-8deg);
  top: 337px;
}

.roadVV_1 {
  position: absolute;
  width: 60px;
  height: 6px;
  left: 379px;
  transform: rotate(-9deg);
  top: 329px;
}

.roadWW_1 {
  position: absolute;
  width: 31px;
  height: 6px;
  left: 438px;
  transform: rotate(-9deg);
  top: 322px;
}

.roadXX_1 {
  position: absolute;
  width: 47px;
  height: 6px;
  left: 416px;
  transform: rotate(91deg);
  top: 345px;
}

.roadXX_2 {
  position: absolute;
  width: 14px;
  height: 6px;
  left: 435px;
  transform: rotate(55deg);
  top: 373px;
}

.roadXX_3 {
  position: absolute;
  width: 28px;
  height: 6px;
  left: 444px;
  transform: rotate(-4deg);
  top: 377px;
}

.roadYY_1 {
  position: absolute;
  width: 76px;
  height: 6px;
  left: 439px;
  transform: rotate(86deg);
  top: 412px;
}

.roadZZ_1 {
  position: absolute;
  width: 57px;
  height: 6px;
  left: 444px;
  transform: rotate(86deg);
  top: 346px;
}

.roadAB_1 {
  position: absolute;
  width: 44px;
  height: 6px;
  left: 312px;
  transform: rotate(86deg);
  top: 317px;
}

.roadAC_1 {
  position: absolute;
  width: 44px;
  height: 6px;
  left: 357px;
  transform: rotate(86deg);
  top: 312px;
}

.roadAD_1 {
  position: absolute;
  width: 38px;
  height: 6px;
  left: 450px;
  transform: rotate(86deg);
  top: 299px;
}

.roadAE_1 {
  position: absolute;
  width: 12px;
  height: 6px;
  left: 242px;
  transform: rotate(124deg);
  top: 304px;
}

.roadAE_2 {
  position: absolute;
  width: 82px;
  height: 6px;
  left: 249px;
  transform: rotate(-6deg);
  top: 297px;
}

.roadAF_1 {
  position: absolute;
  width: 46px;
  height: 6px;
  left: 330px;
  transform: rotate(-6deg);
  top: 290px;
}

.roadAG_1 {
  position: absolute;
  width: 92px;
  height: 6px;
  left: 375px;
  transform: rotate(-5deg);
  top: 284px;
}

.roadAH_1 {
  position: absolute;
  width: 18px;
  height: 6px;
  left: 322px;
  transform: rotate(86deg);
  top: 282px;
}

.roadAI_1 {
  position: absolute;
  width: 14px;
  height: 6px;
  left: 369px;
  transform: rotate(86deg);
  top: 281px;
}

.roadAJ_1 {
  position: absolute;
  width: 16px;
  height: 6px;
  left: 459px;
  transform: rotate(86deg);
  top: 273px;
}

.roadAK_1 {
  position: absolute;
  width: 48px;
  height: 6px;
  left: 328px;
  transform: rotate(-4deg);
  top: 274px;
}

.roadAL_1 {
  position: absolute;
  width: 90px;
  height: 6px;
  left: 375px;
  transform: rotate(-5.5deg);
  top: 268px;
}

.roadAM_1 {
  position: absolute;
  width: 102px;
  height: 6px;
  left: 464px;
  transform: rotate(-5.5deg);
  top: 259px;
}

.roadAN_1 {
  position: absolute;
  width: 44px;
  height: 6px;
  left: 306px;
  transform: rotate(85deg);
  top: 252px;
}

.roadAO_1 {
  position: absolute;
  width: 65px;
  height: 6px;
  left: 432px;
  transform: rotate(86deg);
  top: 229px;
}

.roadAP_1 {
  position: absolute;
  width: 76px;
  height: 6px;
  left: 237px;
  transform: rotate(-15deg);
  top: 243px;
}

.roadAQ_1 {
  position: absolute;
  width: 15px;
  height: 6px;
  left: 311px;
  transform: rotate(-15deg);
  top: 231.5px;
}

.roadAR_1 {
  position: absolute;
  width: 69px;
  height: 6px;
  left: 324px;
  transform: rotate(-14deg);
  top: 221.5px;
}

.roadAS_1 {
  position: absolute;
  width: 29px;
  height: 6px;
  left: 391px;
  transform: rotate(-14deg);
  top: 209.5px;
}

.roadAT_1 {
  position: absolute;
  width: 44px;
  height: 6px;
  left: 418px;
  transform: rotate(-14deg);
  top: 201px;
}

.roadAU_1 {
  position: absolute;
  width: 101px;
  height: 6px;
  left: 459px;
  transform: rotate(-14deg);
  top: 184px;
}

.roadAV_1 {
  position: absolute;
  width: 18px;
  height: 6px;
  left: 303px;
  transform: rotate(84deg);
  top: 223px;
}

.roadAW_1 {
  position: absolute;
  width: 48px;
  height: 6px;
  left: 369px;
  transform: rotate(86deg);
  top: 188px;
}

.roadAX_1 {
  position: absolute;
  width: 44px;
  height: 6px;
  left: 396px;
  transform: rotate(86deg);
  top: 183px;
}

.roadAY_1 {
  position: absolute;
  width: 37px;
  height: 6px;
  left: 442px;
  transform: rotate(86deg);
  top: 176px;
}

.roadAZ_1 {
  position: absolute;
  width: 49px;
  height: 6px;
  left: 230px;
  transform: rotate(-6deg);
  top: 217px;
}

.roadBA_1 {
  position: absolute;
  width: 37px;
  height: 6px;
  left: 277px;
  transform: rotate(-6deg);
  top: 213px;
}

.roadBC_1 {
  position: absolute;
  width: 40px;
  height: 6px;
  left: 259px;
  transform: rotate(85deg);
  top: 193px;
}

.roadBD_1 {
  position: absolute;
  width: 40px;
  height: 6px;
  left: 289px;
  transform: rotate(85deg);
  top: 191px;
}

.roadBE_1 {
  position: absolute;
  width: 36px;
  height: 6px;
  left: 274px;
  transform: rotate(-5deg);
  top: 170px;
}

.roadBF_1 {
  position: absolute;
  width: 84px;
  height: 6px;
  left: 306px;
  transform: rotate(-5deg);
  top: 165px;
}

.roadBG_1 {
  position: absolute;
  width: 30px;
  height: 6px;
  left: 388px;
  transform: rotate(-5deg);
  top: 160px;
}

.roadBH_1 {
  position: absolute;
  width: 42px;
  height: 6px;
  left: 417px;
  transform: rotate(-5deg);
  top: 157px;
}

.roadBI_1 {
  position: absolute;
  width: 100px;
  height: 6px;
  left: 456px;
  transform: rotate(-5deg);
  top: 151px;
}

.roadBJ_1 {
  position: absolute;
  width: 13px;
  height: 6px;
  left: 556px;
  transform: rotate(-5deg);
  top: 147px;
}

.roadBK_1 {
  position: absolute;
  width: 32px;
  height: 6px;
  left: 259px;
  transform: rotate(84deg);
  top: 153px;
}

.roadBL_1 {
  position: absolute;
  width: 42px;
  height: 6px;
  left: 250.5px;
  transform: rotate(84deg);
  top: 120px;
}

.roadBM_1 {
  position: absolute;
  width: 21px;
  height: 6px;
  left: 258.5px;
  transform: rotate(84deg);
  top: 90px;
}

.roadBN_1 {
  position: absolute;
  width: 37px;
  height: 6px;
  left: 270px;
  transform: rotate(-4deg);
  top: 137px;
}

.roadBO_1 {
  position: absolute;
  width: 35px;
  height: 6px;
  left: 265px;
  transform: rotate(-6deg);
  top: 81.5px;
  z-index: 99;
}

.roadBP_1 {
  position: absolute;
  width: 53px;
  height: 6px;
  left: 275px;
  transform: rotate(85deg);
  top: 108px;
}

.roadBQ_1 {
  position: absolute;
  width: 35px;
  height: 6px;
  left: 287.5px;
  transform: rotate(85deg);
  top: 150px;
}

.roadBR_1 {
  position: absolute;
  width: 55px;
  height: 6px;
  left: 218px;
  transform: rotate(-6deg);
  top: 100px;
}

.isSel {
  background: darkorange;
}

.mapContent {
  width: 800px;
  height: 600px;
  background-image: url(img/map.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  top: 350px;
  left: 33%;
  pointer-events: all;
  z-index: 999;
  transform: scale(1.3);
}
</style>
